import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Radios,
  Button,
  Details,
  ErrorSummary,
  Fieldset,
} from 'govuk-react-jsx';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  setPmcLandlordType,
  getPmcLandlordType,
} from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';
import { updateAccount } from '../../firebase';
import useGaStartEvent from '../../hooks/useGaStartEvent';

const LandlordType = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const pmcLandlordTypeRedux = useSelector(getPmcLandlordType);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcClientReg.LandlordType.s19',
    'What type of landlord is your client? - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  useGaStartEvent('PmcClientRegistration', 'pmc_cl_reg_start');

  const errorMsg = {
    children: copyProvider.getCopy(
      'pmcClientReg.LandlordType.s18',
      'Select an option'
    ),
  };

  const detailsSummaryChildren = copyProvider.getCopy(
    'pmcClientReg.LandlordType.s5',
    'What is a public authority or social housing provider?'
  );

  const handleSelection = (event) => {
    dispatch(setPmcLandlordType(event.target.value));
  };

  const handleBtnClick = () => {
    if (!pmcLandlordTypeRedux) {
      setError(errorMsg);
      setErrorList([{ ...errorMsg, href: '#landlordTypepmcReg' }]);
    } else {
      updateAccount({
        landlordType: pmcLandlordTypeRedux,
      })
        .then(() => {
          setError(null);
          if (pmcLandlordTypeRedux === 'Private Landlord') {
            history.push('/pmcClientReg/linked-enterprise');
          } else {
            history.push('/pmcClientReg/company-registration-number');
          }
        })
        .catch(() => {
          setError(errorMsg);
          setErrorList([{ ...errorMsg, href: '#landlordTypepmcReg' }]);
        });
    }
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <Fieldset
        legend={{
          children: (
            <h1 className="govuk-heading-xl">
              {copyProvider.getCopy(
                'pmcClientReg.LandlordType.s1',
                'What type of landlord is your client?'
              )}
            </h1>
          ),
        }}
      >
        <Radios
          onClick={(event) => handleSelection(event)}
          value={pmcLandlordTypeRedux}
          errorMessage={error}
          idPrefix="landlordTypepmcReg"
          items={[
            {
              children: copyProvider.getCopy(
                'pmcClientReg.LandlordType.s2',
                'Private landlord'
              ),
              value: 'Private Landlord',
            },

            {
              children: copyProvider.getCopy(
                'pmcClientReg.LandlordType.s3',
                'Public authority'
              ),
              value: 'Public Authority',
            },
            {
              children: copyProvider.getCopy(
                'pmcClientReg.LandlordType.s4',
                'Property factor or a social housing provider'
              ),
              value: 'Property factor or a social housing provider',
            },
          ]}
        />
      </Fieldset>

      <Details summaryChildren={detailsSummaryChildren}>
        <p>
          <span>{copyProvider.getCopy('pmcClientReg.LandlordType.s6')}</span>
          <strong>
            {copyProvider.getCopy('pmcClientReg.LandlordType.s7')}
          </strong>
          <span>{copyProvider.getCopy('pmcClientReg.LandlordType.s8')}</span>
        </p>
        <p>{copyProvider.getCopy('pmcClientReg.LandlordType.s9')}</p>
        <p>
          {copyProvider.getCopy('pmcClientReg.LandlordType.s10')}
          <span>
            <Link
              to={{}}
              onClick={() =>
                window.open(
                  'https://www.ons.gov.uk/economy/nationalaccounts/uksectoraccounts/datasets/publicsectorclassificationguide',
                  '_blank'
                )
              }
              className="govuk-link"
            >
              {copyProvider.getCopy('pmcClientReg.LandlordType.s11')}
            </Link>
          </span>
        </p>
        <p>
          <span>{copyProvider.getCopy('pmcClientReg.LandlordType.s6')}</span>
          <strong>
            {copyProvider.getCopy('pmcClientReg.LandlordType.s13')}
          </strong>
          <span>{copyProvider.getCopy('pmcClientReg.LandlordType.s14')}</span>
        </p>
        <p>
          <strong>
            {copyProvider.getCopy('pmcClientReg.LandlordType.s15')}
          </strong>
          <span>{copyProvider.getCopy('pmcClientReg.LandlordType.s16')}</span>
        </p>
      </Details>

      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'pmcClientReg.LandlordType.s17',
          'Save and continue'
        )}
      </Button>
    </>
  );

  return pageModel;
};

export default LandlordType;
